/* eslint-disable no-magic-numbers */
import { DateTime } from "luxon";
import * as R from "ramda";
import { getFaker } from "Apimocks/utils/getFaker";

const dateStart = DateTime.utc(2020, 7, 1);
const dateEnd = DateTime.utc();

const randomDate = faker =>
    DateTime.fromMillis(
        faker.random.number({
            min: dateEnd.toMillis(),
            max: dateStart.toMillis(),
        })
    );

/// obj = { author, archived, content, date, id, replies }
export const generateSingleComment = async ({
    maxDepth = 1, minReplies = 1, maxReplies = 30, archived, ...obj 
} = {}, depth = 0) => {
    const faker = await getFaker();
    const date = randomDate(faker);
    const isOwnComment = depth === 0 ? true : faker.random.boolean();
    return ({
        archived: archived ?? faker.random.boolean(),
        author: faker.fake("{{name.firstName}} {{name.lastName}}"),
        canArchive: isOwnComment,
        canEdit: isOwnComment,
        content: faker.lorem.sentences(),
        date: date.toRelative(),
        id: faker.random.uuid(),
        replies: depth < maxDepth
            ? Promise.all(R.range(minReplies, maxReplies).map(idx =>
                generateSingleComment(
                    {
                        ...obj,
                        // eslint-disable-next-line no-mixed-operators
                        archived: idx < 6 && idx > 2 ? !(idx % 2) : obj.archived,
                        maxDepth, 
                        maxReplies,
                        minReplies, 
                    },
                    depth + 1
                )
            ))
            : [],
        ts: date.valueOf(),
        ...obj,
    });
};

/**
 * @param structure (array)
 *  - a base structure for the comments data with only `archived`, `replies` and `isArchived` keys as numbers
 *    (e.g. [{replies: 4, archived: 2}, {replies: 3, archived: 0, isArchived: true}])
 */
export const mockCommentsData = structure =>
    Promise.all(structure.map(generateSingleComment));
